export default {
  PUBLIC: "公众帐户",
  SCHOOL_BASED_TEACHER: "校本教师帐户",
  INDIVIDUAL_TEACHER: "个人教师帐户",
  STUDENT: "学生帐户",
  SCHOOL_ADMINISTRATOR: "学校管理员帐户",
  SCHOOL: "学校职员帐户",
  CORPORATE_ADMINISTRATOR: "企业管理员帐户",
  OTHER: "其他",
  STUDENT_MEMBER:"学生会员",
  FULL_MEMBER:"会员",
  SCHOOL_PURCHASER:"学校採购员帐户",
};
